import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    Stack,
    TextField,
    Typography
} from '@mui/material';
import React, { useMemo } from 'react';
import { OpenModalHookType } from '@hooks/useOpenModal';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { PromotionalCode } from '@api/PromotionalCodes/PromotionalCode';
import * as Yup from 'yup';
import { Controller, SubmitHandler, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { showAlertError } from '@utils/Alerts/Error';
import { useSelector } from 'react-redux';
import { RootReducer } from '@store/index';
import PromotionalCodeService from '@api/PromotionalCodes/PromotionalCodeCtrl';
import { hideLoader, showLoader } from '@utils/Loader';

interface ModalAddPromotionalCodeProps {
    modalAddPromotionalCode: OpenModalHookType;
    onAddPromotionalCode: (promotionalCode: PromotionalCode) => void;
}

const addPromotionalCodeSchema = Yup.object({
    code: Yup.string().required('Código requerido')
});
export const ModalAddPromotionalCode: React.FunctionComponent<ModalAddPromotionalCodeProps> = (props: any) => {
    const { modalAddPromotionalCode, onAddPromotionalCode } = props;
    const { branchOfficeSelected } = useSelector((state: RootReducer) => state.auth);
    const promotionalCodeService = useMemo(() => new PromotionalCodeService(), []);

    const {
        control,
        handleSubmit,
        reset,
        formState: { errors }
    } = useForm<{ code: string }>({
        resolver: yupResolver(addPromotionalCodeSchema)
    });

    const onAddCode: SubmitHandler<{ code: string }> = async (values) => {
        showLoader();
        try {
            if (branchOfficeSelected?.id) {
                const promotionalCode = await promotionalCodeService.verifyCode(values.code, branchOfficeSelected.id);
                handleClose();
                reset();
                onAddPromotionalCode(promotionalCode);
            }
        } catch (error) {
            showAlertError(error);
        }
        hideLoader();
    };

    const handleClose = () => {
        modalAddPromotionalCode.toggle();
    };

    return (
        <Dialog
            PaperProps={{
                style: { borderRadius: 15, padding: 4 }
            }}
            open={modalAddPromotionalCode.modalOpen}
            onClose={handleClose}
            aria-labelledby="modal-product-info-title"
            aria-describedby="modal-product-info-description"
            fullWidth
            maxWidth="sm"
        >
            <DialogTitle id="modal-product-info-title">
                <Stack direction="row" justifyContent="space-between" alignItems="center">
                    <Typography variant="h6" fontWeight={600}>
                        Agregar una promoción
                    </Typography>
                    <IconButton color="secondary" onClick={handleClose}>
                        <CloseIcon />
                    </IconButton>
                </Stack>
            </DialogTitle>
            <DialogContent>
                <form id="add-promotional-code-form" onSubmit={handleSubmit(onAddCode)}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} mt={1}>
                            <Controller
                                name="code"
                                control={control}
                                defaultValue=""
                                render={({ field: { onChange, value } }) => (
                                    <TextField
                                        fullWidth
                                        required
                                        label="Ingresa un código promocional"
                                        variant="outlined"
                                        value={value}
                                        onChange={onChange}
                                        error={!!errors.code}
                                        helperText={errors.code && errors.code.message}
                                    />
                                )}
                            />
                        </Grid>
                    </Grid>
                </form>
            </DialogContent>
            <DialogActions>
                <Button fullWidth color="primary" variant="contained" type="submit" form="add-promotional-code-form">
                    Agregar promoción
                </Button>
            </DialogActions>
        </Dialog>
    );
};
